export default {
  buttons: {
    login: 'Log ind',
  },
  feedback: {
    incorrect_code: 'Den indtastede kode er forkert. Prøv igen.',
    expired_code: 'Denne kode er udløbet. Anmod om en ny.',
    too_many_attempts: 'For mange forsøg. Vent et øjeblik, og prøv igen.',
    unknown: 'Noget gik galt under bekræftelsen af din kode. Prøv igen.',
    network_error: 'Vi kunne ikke få forbindelse til serveren. Tjek din forbindelse, og prøv igen.',
  },
};
